var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2852,
    y1: 511.0804,
    x2: 2.2901,
    y2: 511.0804,
    gradientTransform: "matrix(126.2799 125.5782 -125.2988 126.5615 64049.7422 -64670.543)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#387EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#366994"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.2,1.3c-130,0-121.9,56.4-121.9,56.4l0.1,58.4h124v17.5H83.2c0,0-83.2-9.4-83.2,121.7 c0,131.1,72.6,126.5,72.6,126.5h43.3V321c0,0-2.3-72.6,71.4-72.6h123c0,0,69.1,1.1,69.1-66.8V69.3C379.5,69.3,390,1.3,254.2,1.3z  M185.8,40.6c12.3,0,22.3,10,22.3,22.3c0,12.3-10,22.3-22.3,22.3s-22.3-10-22.3-22.3C163.4,50.6,173.4,40.6,185.8,40.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.8921,
    y1: 511.1571,
    x2: 2.8969,
    y2: 511.1571,
    gradientTransform: "matrix(135.625 128.783 -128.4964 135.9275 65764.5781 -69385.4766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC331"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.8,510.7c130,0,121.9-56.4,121.9-56.4l-0.1-58.4h-124v-17.5h173.3c0,0,83.2,9.4,83.2-121.7 c0-131.1-72.6-126.5-72.6-126.5h-43.3V191c0,0,2.3,72.6-71.4,72.6h-123c0,0-69.1-1.1-69.1,66.8v112.3 C132.5,442.7,122,510.7,257.8,510.7z M326.2,471.4c-12.3,0-22.3-10-22.3-22.3c0-12.3,10-22.3,22.3-22.3s22.3,10,22.3,22.3 C348.6,461.4,338.6,471.4,326.2,471.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython04);
export default __webpack_public_path__ + "static/media/Python-04.2da61ce8f5fe418d232dc348c8a522fa.svg";
export { ForwardRef as ReactComponent };